var map = {
	"./MBudget.svg": 1160,
	"./Mtel.svg": 1112,
	"./Quickline.svg": 1110,
	"./Salt.svg": 1107,
	"./Spusu.svg": 1113,
	"./Swisscom.svg": 1105,
	"./TalkTalk.svg": 1111,
	"./Wingo.svg": 1106,
	"./migros.svg": 1109,
	"./yallo.svg": 1108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1159;